/**
 * @flow
 * @relayHash 6a0572fa9048efcdb9e3c7ffb22b41e4
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateUserInput = {
  active?: ?boolean,
  email?: ?string,
  id: string,
  name?: ?string,
  clientMutationId: string,
};
export type UpdateUserMutationVariables = {|
  input: UpdateUserInput
|};
export type UpdateUserMutationResponse = {|
  +updateUser: ?{|
    +user: ?{|
      +id: string,
      +name: string,
      +email: string,
      +active: boolean,
    |}
  |}
|};
*/

/*
mutation UpdateUserMutation(
  $input: UpdateUserInput!
) {
  updateUser(input: $input) {
    user {
      id
      name
      email
      active
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: "LocalArgument",
        name: "input",
        type: "UpdateUserInput!",
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "updateUser",
        storageKey: null,
        args: [
          {
            kind: "Variable",
            name: "input",
            variableName: "input",
            type: "UpdateUserInput!"
          }
        ],
        concreteType: "UpdateUserPayload",
        plural: false,
        selections: [
          {
            kind: "LinkedField",
            alias: null,
            name: "user",
            storageKey: null,
            args: null,
            concreteType: "User",
            plural: false,
            selections: [
              {
                kind: "ScalarField",
                alias: null,
                name: "id",
                args: null,
                storageKey: null
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "name",
                args: null,
                storageKey: null
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "email",
                args: null,
                storageKey: null
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "active",
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: "Request",
    operationKind: "mutation",
    name: "UpdateUserMutation",
    id: null,
    text:
      "mutation UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      id\n      name\n      email\n      active\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "UpdateUserMutation",
      type: "Mutation",
      metadata: null,
      argumentDefinitions: v0,
      selections: v1
    },
    operation: {
      kind: "Operation",
      name: "UpdateUserMutation",
      argumentDefinitions: v0,
      selections: v1
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '23cdb6316816caa3c5146bde067276e5';
module.exports = node;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/UpdateUserMutation.graphql.js